import { render } from "./ButhiToolbar.vue?vue&type=template&id=3fcdb31b&scoped=true"
import script from "./ButhiToolbar.vue?vue&type=script&lang=js"
export * from "./ButhiToolbar.vue?vue&type=script&lang=js"

import "./ButhiToolbar.vue?vue&type=style&index=0&id=3fcdb31b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wkphi\\Desktop\\Programming\\buthigame - Copy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcdb31b"]])

export default __exports__